export const interceptorMessageMapping = [
  {
    method: "post",
    url: "/configuration/assignoption",
    message: "Option assigned successfully.",
  },
  {
    method: "post",
    url: "/configuration/unassignoption",
    message: "Option unassigned successfully.",
  },
  {
    method: "post",
    url: "/configuration/updatechoice",
    message: "Choice updated successfully.",
  },
  {
    method: "post",
    url: "/configuration/updateoption",
    message: "Option updated successfully.",
  },
  {
    method: "post",
    url: "/configuration/updatesection",
    message: "Section updated successfully.",
  },
  {
    method: "post",
    url: "/configuration/updatemodel",
    message: "Model updated successfully.",
  },
  {
    method: "post",
    url: "/configuration/updateseries",
    message: "Series updated successfully.",
  },
  {
    method: "post",
    url: "/configuration/updateprint",
    message: "Print configuration updated successfully.",
  },
  {
    method: "post",
    url: "/configuration/removeimage",
    message: "Image removed successfully.",
  },
  {
    method: "post",
    url: "/configuration/removechoiceimage",
    message: "Image updated successfully.",
  },
  {
    method: "post",
    url: "/configuration/updateimage",
    message: "Image uploaded successfully.",
  },
  {
    method: "post",
    url: "/configuration/importchoiceimage",
    message: "Image uploaded successfully.",
  },
  {
    method: "post",
    url: "/configuration/updateimage",
    message: "Order updated successfully.",
  },
  {
    method: "post",
    url: "/user/resetpassword",
    message: "Password updated successfully."
  },
  {
    method: "post",
    url: "/user/updatename",
    message: "Name updated successfully."
  },
  {
    method: "post",
    url: "/user/updatecontact",
    message: "Email updated successfully."
  },
  {
    method: "post",
    url: "/usermanagement",
    message: "Save Successful."
  },
  {
    method: "post",
    url: "/parts",
    message: "Motor updated successfully."
  },
  {
    method: "post",
    url: "/importdata",
    message: "Data Imported Successfully."
  },
  {
      method: "post",
      url: "/lookup/savefinanceterm",
      message: "Terms updated successfully."
  },
  {
      method: "post",
      url: "/lookup/savedeliverymethod",
      message: "Delivery updated successfully."
  },
  {
      method: "post",
      url: "/lookup/savefreightmethod",
      message: "Shipping updated successfully."
  }
];
